import React from 'react'

export default function Notification() {
    return (
        <div>
            <h1>this is a Notification funtion</h1>
        </div>
    )
}
